import config from '@/config';
import { apiPublicInstance } from '@/services/API';

export interface SupportDeskTicket {
  serviceDeskId: string;
  requestTypeId: string;
  raiseOnBehalfOf: string;
  requestFieldValues: {
    summary: string;
    description: string;
  };
}

export const serviceDeskId = config.serviceDeskId;
export const requestTypeId = config.serviceDeskRequestId;
export const irebyUrl = config.irebyUrl;

export const createSupportTicket = async (ticket: SupportDeskTicket): Promise<boolean> => {
  try {
    const result = await apiPublicInstance().post('/api/serviceDesk', ticket);
    return result.data;
  } catch (error) {
    return false;
  }
};

export const createHeaderSupportTicket = async (email: string, currentRoute: string): Promise<string> => {
  try {
    const platform = await apiPublicInstance().get(`/api/platforms/${config.platformUuid}`);
    return `
    Platform ID: ${config.platformUuid}
    Nom de la plateforme: ${platform.data.name}
    Path courant du ticket: ${currentRoute}
    Email de l'utilisateur: ${email}
  `;
  } catch (error) {
    return `
    Platform ID: ${config.platformUuid}
    Nom de la plateforme: ${error}
    Path courant du ticket: ${currentRoute}
    Email de l'utilisateur: ${email}
  `;
  }
};

export const getServiceDeskRequestTypes = async (sdId: number): Promise<any> => {
  return apiPublicInstance()
    .get(`/api/serviceDesk/${sdId}/requestTypes?general=true`)
    .then((res) => res.data)
    .catch((err) => console.error(err));
};
